import revive_payload_client_4sVQNw7RlN from "/usr/src/rt-details-2023/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import _00_canonical_payload_path_zCBt3Jkkst from "/usr/src/rt-details-2023/plugins/00-canonical-payload-path.ts";
import unhead_KgADcZ0jPj from "/usr/src/rt-details-2023/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/usr/src/rt-details-2023/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_MwZUzHrRNP from "/usr/src/rt-details-2023/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/usr/src/rt-details-2023/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/usr/src/rt-details-2023/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import chunk_reload_client_UciE0i6zes from "/usr/src/rt-details-2023/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/usr/src/rt-details-2023/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/usr/src/rt-details-2023/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/usr/src/rt-details-2023/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_IJZcPvBsSf from "/usr/src/rt-details-2023/node_modules/nuxt-highcharts/lib/plugin.js";
import _01_sanitize_html_FysGffaHDH from "/usr/src/rt-details-2023/plugins/01.sanitize-html.ts";
import common_clib_Pj5GAC1sLE from "/usr/src/rt-details-2023/plugins/common-clib.ts";
import frontiers_clib_config_hHaxZHvMpg from "/usr/src/rt-details-2023/plugins/frontiers-clib-config.ts";
import gtm_tracking_client_I9u8Vy1cUj from "/usr/src/rt-details-2023/plugins/gtm.tracking.client.ts";
import register_gsap_client_bQW9RmNu8r from "/usr/src/rt-details-2023/plugins/register-gsap.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  _00_canonical_payload_path_zCBt3Jkkst,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_MwZUzHrRNP,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_IJZcPvBsSf,
  _01_sanitize_html_FysGffaHDH,
  common_clib_Pj5GAC1sLE,
  frontiers_clib_config_hHaxZHvMpg,
  gtm_tracking_client_I9u8Vy1cUj,
  register_gsap_client_bQW9RmNu8r
]